import React, { useState, useEffect, useContext } from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CssBaseline from '@material-ui/core/CssBaseline';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import DateFnsUtils from '@date-io/date-fns';
import { parseISO, format } from 'date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import GenericDialogBox from '../../components/GenericDialogBox';
import InfoBox from '../../components/InfoBox';
import DataService from "../../services/data.service";
import DetailTable from './DetailTable';
import { useTranslation } from "react-i18next";
import PermissionContext from '../../contexts/PermissionContext';
import { alpha } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(22),
        maxWidth: 400,
        margin: 'auto',
        overflow: 'hidden',
        backgroundColor: 'white'
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {

        margin: theme.spacing(3, 2, 2),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));


const endpoint = `cash-aux-detail`
const DATE_FORMAT = 'yyyy-MM-dd';

const CashAuxdetailForm = React.forwardRef((props, ref) => {
    const { t } = useTranslation();
    const { cashId, permission } = props;

    const { userHasPermission } = useContext(PermissionContext)

    // console.log("UHP",userHasPermission)

    let hasPerm = userHasPermission(permission, 'can_list')
    let hasAddPerm = userHasPermission(permission, 'can_post')
    let hasEditPerm = userHasPermission(permission, 'can_patch')
    let hasGetPerm = userHasPermission(permission, 'can_get')
    let hasDeletePerm = userHasPermission(permission, 'can_delete')
    // for detail form
    let hasDeleteDetailPerm = userHasPermission(`${permission}-detail`, 'can_delete')

    const [amountValue, setAmountValue] = useState(0.00);
    const [conceptValue, setConceptValue] = useState("");
    const [affectsCashAux, setAffectsCashAux] = useState(true);
    const handleChecked = (event) => {
        setAffectsCashAux(event.target.checked);
    };

    // INFO NOTIFICATION VARS
    const [infoOpen, setInfoOpen] = useState(false);
    const [infoTitle, setInfoTitle] = useState('');
    const [infoBody, setInfoBody] = useState('');
    //***********************

    //Dialog Vars
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogueTitle, setDialogueTitle] = useState('');
    const [dialogueBody, setDialogueBody] = useState('');
    //**********

    // DIALOG FUNCTIONS
    const handleDialogOk = () => {
        setDialogOpen(false)
    };

    const handleDialogClose = () => {
        setDialogOpen(false)
    };

    const openDialogBox = (title, body) => {
        setDialogueTitle(title)
        setDialogueBody(body)
        setDialogOpen(true)
    };
    //*******************

    // Notification INFO functions
    const openNoticeBox = (title, body) => {
        setInfoTitle(title)
        setInfoBody(body)
        setInfoOpen(true)
    };

    const handleInfoClose = () => {
        setInfoOpen(false)
    };
    // *****************


    const addData = (values) => {
        DataService.create(`${endpoint}/`, values)
            .then(response => {
                openNoticeBox("Notice", t("record_created_successfully", { "table": t("cash_table_title") }))
            })
            .catch(e => {
                openNoticeBox("Error", `Code: ${e.response.status} Message: ${e.response.statusText} - ${e.response.data.detail}`)
            });
    }

    const submitForm = (event) => {
        event.preventDefault();
        // var newDate, newDueDate = ""
        // newDate = format(selectedDate, DATE_FORMAT)

        let values = {
            'amount': amountValue,
            'concept': conceptValue,
            'cash_aux_id': cashId,
            'affects_main_cash': affectsCashAux,
        }

        addData(values)

    }

    const handleReset = (event) => {

    }

    const classes = useStyles();

    return (
        <Paper className={classes.paper}>
            <CssBaseline />
            <GenericDialogBox
                opn={dialogOpen}
                handleDialogOk={handleDialogOk}
                handleDialogClose={handleDialogClose}
                title={dialogueTitle}
                body={dialogueBody} />
            <InfoBox
                opn={infoOpen}
                handleDialogClose={handleInfoClose}
                title={infoTitle}
                body={infoBody} />

            <form className={classes.form} onSubmit={submitForm} onReset={handleReset}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h4" component="h4">
                            {t("cash_form_cash_aux_id")}: {cashId ? cashId : 0}
                        </Typography>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="amount"
                            label={t("cash_form_lbl_cash_amount")}
                            name="amount"
                            onChange={event => setAmountValue(event.target.value)}
                            value={amountValue}
                            style={{ marginTop: '5px' }}
                        />
                        <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            id="concept"
                            label={t("cash_form_lbl_cash_concept")}
                            name="concept"
                            multiline
                            maxRows={4}
                            onChange={event => setConceptValue(event.target.value)}
                            value={conceptValue}
                            style={{ marginTop: '-2px' }}
                        />
                        <FormControlLabel
                            value={affectsCashAux}
                            checked={affectsCashAux}
                            control={<Checkbox color="primary" />}
                            label={t("cash_aux_detail_affects_cash")}
                            labelPlacement="end"
                            onChange={handleChecked}
                            name="affects_cash_aux"
                            disabled={false}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                            disabled={cashId === 0 ? false : !hasAddPerm ? true : !hasEditPerm ? true : false}
                        >
                            {t("save_form_button")}

                        </Button>
                    </Grid>
                </Grid>
            </form>
            <Box mt={8}>

            </Box>

        </Paper>
    )
})

export default CashAuxdetailForm;
    // ReactDOM.render(<WithMaterialUI />, document.getElementById('root'));
